/**
 * Date helpers. Dates are stored as ISO calendar dates ("YYYY-MM-DD", UTC)
 * and timestamps as ISO-8601 UTC strings — both sort correctly as text in
 * SQLite and match D1's `date('now')` / `strftime(...,'now')` defaults.
 */

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

export const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/** Today as "YYYY-MM-DD" in UTC (matches the API's `date('now')`). */
export function todayISODate(): string {
  return new Date().toISOString().slice(0, 10);
}

export function isValidISODate(value: string): boolean {
  if (!ISO_DATE_REGEX.test(value)) return false;
  return !Number.isNaN(Date.parse(`${value}T00:00:00Z`));
}

/** "2026-09-14" -> "14 Sep 2026"; null/undefined -> "—". */
export function formatDateHuman(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return "—";
  return `${d} ${MONTHS[m - 1] ?? "?"} ${y}`;
}

export function nowIso(): string {
  return new Date().toISOString();
}

export function addDaysIso(isoDate: string, days: number): string {
  const d = new Date(`${isoDate}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}
